import { Reducer } from 'redux';

import { loadApp } from '../services/app';
import { ActionTypes } from '../types/action-types';
import { ActionObject, IApp } from '../types/app';

export default ((state = loadApp(), action: ActionObject): IApp => {
  switch (action.type) {
    case ActionTypes.PROFILE_PROJECTS_LOADED:
      return {
        ...state,
        projects: action.projects,
        apiHost: action.apiHost,
      };
    case ActionTypes.PROFILE_CONSENTED_PROJECTS_LOADED:
      return {
        ...state,
        consentedProjects: action.consentedProjects,
        apiHost: action.apiHost,
      };
  }
  return {...state};
}) as Reducer<IApp>;



// WEBPACK FOOTER //
// ./src/reducers/app.ts